import React from 'react';
import PropTypes from 'prop-types';
import { Visible } from '@tfecom-thermofisher/react-komodo-design';

import { Button, Modal, Message, withModal } from 'src/core/components';

import messages from './messages';

const DeleteComponent = ({ label, onDelete, handleClose, handleOpen, isOpen }) => {
  const handleSubmit = () => {
    onDelete();

    handleClose();
  };

  return (
    <>
      <Button
        data-testid="delete-products-btn"
        type="tertiary"
        label={label || messages.delete}
        onClick={handleOpen}
      />
      <Visible when={isOpen}>
        <Modal
          {...{
            submitBtnLabel: messages.delete,
            handleSubmit,
            handleClose,
            isOpen,
            title: messages.removeProjects,
            content: (
              <Message message={messages.confirmDelete} />
            )
          }}
        />
      </Visible>
    </>
  );
};

DeleteComponent.propTypes = {
  label: PropTypes.object,
  onDelete: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleOpen: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};

export default withModal(DeleteComponent);
